<div class="parent-container">
  <div
    [matTooltip]="
      isInactiveWorkflow
        ? 'Inactive post (' +
          stateSignal$().workflow.workflow.promptVersion +
          ')'
        : null
    "
  >
    <div
      class="post-settings"
      [ngClass]="{
        opacity: isInactiveWorkflow,
        'no-opacity': !isInactiveWorkflow
      }"
    >
      <p (click)="openPostSettings()">
        <mat-icon>settings</mat-icon> Post Settings
      </p>
    </div>
  </div>
  <div class="parent-review-container">
    <div class="post-navigator">
      <span class="link" (click)="navigateTo('home')">All posts /</span>
      <div class="editable-container">
        <form [formGroup]="workflowForm">
          <input type="text" formControlName="postName" *ngIf="nameEditing" />
          <span *ngIf="!nameEditing">{{ workflowForm.value.postName }}</span>
          <mat-icon
            role="button"
            *ngIf="!nameEditing"
            (click)="changePostName(true)"
            >edit</mat-icon
          >
          <mat-icon
            role="button"
            *ngIf="nameEditing"
            (click)="changePostName(false)"
            >check</mat-icon
          >
        </form>
      </div>
    </div>
    <div class="post-content">
      <div class="review-process">
        <mat-tab-group animationDuration="300" [(selectedIndex)]="step">
          <mat-tab [disabled]="isInactiveWorkflow">
            <ng-template mat-tab-label>
              <div class="circle">1</div>
              <ng-container *ngIf="isInactiveWorkflow">
                <div>
                  Editing is disabled for
                  {{ stateSignal$().workflow.workflow.promptVersion }} posts
                </div>
              </ng-container>
              <ng-container *ngIf="!isInactiveWorkflow">
                <div>Create Post Content</div>
              </ng-container>
            </ng-template>
            <div>
              <ng-template matTabContent>
                <ng-container
                  *ngIf="
                    this.workflowId === stateSignal$().workflow.workflow.uid
                  "
                >
                  <postgenie-result-editing></postgenie-result-editing>
                </ng-container>
              </ng-template>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="circle">2</div>
              <div>Preview Post</div>
            </ng-template>
            <div>
              <ng-template matTabContent>
                <ng-container
                  *ngIf="
                    this.workflowId === stateSignal$().workflow.workflow.uid
                  "
                >
                  <postgenie-result-review
                    [user]="user"
                  ></postgenie-result-review>
                </ng-container>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div class="review-helper">
        <div class="next-button">
          <ng-container *ngIf="step === 0">
            <button class="btn btn-primary" (click)="nextStep()">
              Next step
            </button>
          </ng-container>
          <ng-container *ngIf="step === 1">
            <button class="btn btn-primary" (click)="copyToClipboard()">
              Copy post
            </button>
          </ng-container>
        </div>
        <div class="helper">
          <div class="tips box">
            <p class="tips-header">LinkedIn Tips for increasing reach</p>
            <div class="container-tips">
              <div
                class="item"
                *ngFor="let item of items"
                (click)="toggle(item)"
              >
                <div class="title">
                  {{ item.title }}
                </div>
                <div class="description" *ngIf="item.expanded">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
